module.exports = __webpack_public_path__ + "img/sui3.0920f25f.png";